// 角色的下拉框
// 全局变量事件类型数据
var logEventType = {
  0x000: {
    label: "Login",
    code: 0x000,
    logInfo: "@:operationLog.dict.accountAndName  Login successful!"
  },
  0x001: {
    label: "Logout",
    code: 0x001,
    logInfo: " @:operationLog.dict.accountAndName Logout successful"
  },
  0xa00: {
    label: "The new agent", //新增代理
    code: 0xa00,
    logInfo: " add @:operationLog.dict.accountAndName"
  },
/*  0xa01: {
    label: "编辑代理",
    code: 0xa01,
    logInfo: " 新增 @:operationLog.dict.accountAndName"
  },*/
  0xa02: {
    label: "Remove the agent",//删除代理
    code: 0xa02,
    logInfo: " Remove @:operationLog.dict.accountAndName"
  },
  0xa03: {
    label: "Suspending agent",//暂停代理
    code: 0xa03,
    logInfo: " pause @:operationLog.dict.accountAndName"
  },
  0xa05: {
    label: "Recovery agent",//恢复代理
    code: 0xa05,
    logInfo: "Recovery agent @:operationLog.dict.accountAndName"
  },
  0xa04: {
    label: "Modify the agent",//修改代理
    code: 0xa04,
    logInfo: "modify @:operationLog.dict.accountAndName"
  },
  0xb00: {
    label: "change password",//修改密码
    code: 0xb00,
    logInfo: "change @:operationLog.dict.accountAndName"
  },
  0xb01: {
    label: "reset the password",//密码重置
    code: 0xb01,
    logInfo: "reset the password @:operationLog.dict.accountAndName"
  },
  0xb02: {
    label: "To modify the domain name",//修改域名
    code: 0xb02,
    logInfo: "To modify the domain name @:operationLog.dict.domain"
  },

  0xc00: {
    label: "The new management",//新增管理
    code: 0xc00,
    logInfo: "The new management @:operationLog.dict.accountAndName"
  },
  0xc01: {
    label: "Change management",//修改管理
    code: 0xc01,
    logInfo: "Change management @:operationLog.dict.accountAndName"
  },
  0xc02: {
    label: "Delete management",//删除管理
    code: 0xc02,
    logInfo: "Delete management @:operationLog.dict.accountAndName"
  },
  0xc03: {
    label: "Suspension of management",//暂停管理
    code: 0xc03,
    logInfo: "Suspension of management @:operationLog.dict.accountAndName"
  },
  0xc04: {
    label: "Administrative password reset",//管理密码重置
    code: 0xc04,
    logInfo: "Administrative password reset @:operationLog.dict.accountAndName"
  },
  0xc05: {
    label: "recovery management ",//恢复管理
    code: 0xc05,
    logInfo: "recovery management  @:operationLog.dict.accountAndName"
  },
  //企业部分
  0x04: {
    label: "The new enterprise",//新增企业
    code: 0x04,
    logInfo: "The new enterprise @:operationLog.dict.accountAndName"
  },
  0x05: {
    label: "Delete the enterprise",//删除企业
    code: 0x05,
    logInfo: "Delete the enterprise @:operationLog.dict.accountAndName"
  },
  0x02: {
    label: "Modify the enterprise",//修改企业
    code: 0x02,
    logInfo: "modify @:operationLog.dict.accountAndName"
  },
  0x03: {
    label: "Suspension of business",//暂停企业
    code: 0x03,
    logInfo: "pause @:operationLog.dict.accountAndName"
  },
    0x06: {
      label: "Restore the enterprise",//恢复企业
      code: 0x06,
      logInfo: "Restore the enterprise @:operationLog.dict.accountAndName"
    },
  //子代理SecMerchant
  0x10: {
    label: "New subagents",//新增子代理
    code: 0x10,
    logInfo: "New subagents @:operationLog.dict.accountAndName"
  },
  0x11: {
    label: "Delete subagents",//删除子代理
    code: 0x11,
    logInfo: "Delete subagents @:operationLog.dict.accountAndName"
  },
  0x12: {
    label: "Modify subagent",//修改子代理
    code: 0x12,
    logInfo: "Modify subagent @:operationLog.dict.accountAndName"
  },
  0x13: {
    label: "Suspend subagent",//暂停子代理
    code: 0x13,
    logInfo: "Suspend subagent @:operationLog.dict.accountAndName"
  },
  0x14: {
    label: "Subagent password reset",//子代理密码重置
    code: 0x14,
    logInfo: "Subagent password reset @:operationLog.dict.accountAndName"
  },
  0x15: {
    label: "Subagent recover",
    code: 0x15,
    logInfo: "Subagent recover @:operationLog.dict.accountAndName"
  },

  //用户
  0xd00: {
    label: "addUsers",//批量新增用户
    code: 0xd00,
    logInfo: "addUsers @:operationLog.dict.accountAndName"
  },
  0xd01: {
    label: "add new users ",//新增用户
    code: 0xd01,
    logInfo: "add new users  @:operationLog.dict.accountAndName"
  },
  0xd02: {
    label: "Modify the user",//修改用户
    code: 0xd02,
    logInfo: "Modify the user @:operationLog.dict.accountAndName"
  },
  0xd03: {
    label: "Delete user",//删除用户
    code: 0xd03,
    logInfo: "Delete user @:operationLog.dict.accountAndName"
  },

  0xd04: {
    label: "Suspended user",//暂停用户
    code: 0xd04,
    logInfo: "Suspend terminal account @:operationLog.dict.accountAndName"
  },

  //群组
  0xe00: {
    label: "New groups (batch)",//批量新增群组
    code: 0xe00,
    logInfo: "New groups (batch)  Group name:{groupName}"
  },
  0xe01: {
    label: "The new group",//新增群组
    code: 0xe01,
    logInfo: "The new group  Group name:{groupName}"
  },
  0xe02: {
    label: "Modify group information",//修改群组信息
    code: 0xe02,
    logInfo: "Modify group information Group name:{groupName},Old Group name:{originName}"
  },
  0xe03: {
    label: "Group membership",//群组增加成员
    code: 0xe03,
    logInfo: "Group membership  @:operationLog.dict.groupLog"
  },

  0xe07: {
    label: "Users add groups",//用户添加群组
    code: 0xe07,
    logInfo: "Users add groups User account:@:operationLog.dict.groupLog"
  },

  0xe04: {
    label: "Group member deletion",//群组删除成员
    code: 0xe04,
    logInfo: "Group member deletion Group id: @:operationLog.dict.groupLog"
  },
  0xe05: {
    label: "Group to suspend",//群组暂停
    code: 0xe05,
    logInfo: "Group to suspend @:operationLog.dict.group,GroupId: {groupId}"
  },

  0xe08: {
    label: "Recovery group",//群组恢复
    code: 0xe08,
    logInfo: "Recovery group @:operationLog.dict.group,GroupId:{groupId}"
  },

  0xe06: {
    label: "Group to delete",//群组删除
    code: 0xe06,
    logInfo: "Group to delete Group name:@:operationLog.dict.group,群组id: {groupId}"
  },
  0xf00: {
    label: "Added friend",//增加好友
    code: 0xf00,
    logInfo: "Added friend Your account:@:operationLog.dict.myAccount,Friends account:@:operationLog.dict.targetAccount,Friends name:@:operationLog.dict.targetName"
  },
  0xf01: {
    label: "delete friend",//删除好友
    code: 0xf01,
    logInfo: "delete friend Your account:@:operationLog.dict.myAccount,Friends account:@:operationLog.dict.targetAccount,Friends name:@:operationLog.dict.targetName"
  },
  0xf02: {
    label: "The message management", //消息管理
    code: 0xf02,
    logInfo: "The message management @:operationLog.dict.accountAndName"
  },
  0xf03: {
    label: "Issued by the radio", //下发广播
    code: 0xf03,
    logInfo: "Issued by the radio @:operationLog.dict.accountAndName"
  },

  //二级管理
  0x21: {
    label: "New level 2 management",//新增二级管理
    code: 0x21,
    logInfo: "New level 2 management @:operationLog.dict.accountAndName"
  },
  0x22: {
    label: "Second-level management modification",//二级管理修改
    code: 0x22,
    logInfo: "Second-level management modification @:operationLog.dict.accountAndName"
  },
  0x23: {
    label: "Administrative deletion of second level",//二级管理删除
    code: 0x23,
    logInfo: "Administrative deletion of second level @:operationLog.dict.accountAndName"
  },
  0x24: {
    label: "Suspension of secondary management",//暂停二级管理
    code: 0x24,
    logInfo: "Suspension of secondary management @:operationLog.dict.accountAndName"
  },

  0xf08: {
    label: "Restoring secondary Management",//恢复二级管理
    code: 0xf08,
    logInfo: "Restoring secondary Management @:operationLog.dict.accountAndName"
  },

  0x25: {
    label: "Second level management password reset",//二级管理密码重置
    code: 0x25,
    logInfo: "Second level management password reset @:operationLog.dict.accountAndName"
  },
  0x026: {
    label: "Account move",
    code: 0x026,
    logInfo: "Operator account:{operatorAccount} Terminal account :{terminalAccount}  From  @:qbLog.dict.originRole account:{originAccount}  move to   @:qbLog.dict.targetRole account:{targetAccount}  "
  },
  0x027: {
    label: "Termination user",
    code: 0x027,
    logInfo: "Operator account: {operatorAccount}  termination   @:qbLog.dict.originRole account:{originAccount} to @:qbLog.dict.targetRole  account:{targetAccount}  "
  },
  0x028: {
    label: "Recovery user",
    code: 0x028,
    logInfo: "Operator account:{operatorAccount}  restore   @:qbLog.dict.targetRole  account :{targetAccount}  From  @:qbLog.dict.originRole account:{originAccount}  "
  },
  0x029: {
    label: "Restore the accounting",//恢复会计
    code: 0x029,
    logInfo: "Restore the accounting @:operationLog.dict.accountAndName"
  },
  0x030: {
    label: "Suspending accounting",//暂停会计
    code: 0x030,
    logInfo: "Suspending accounting @:operationLog.dict.accountAndName"
  },
  0x031: {
    label: "Domain name suspended",//暂停域名
    code: 0x031,
    logInfo: "Domain name suspended @:operationLog.dict.accountAndName"
  },
  0x032: {
    label: "To restore the domain name",//恢复域名
    code: 0x032,
    logInfo: "To restore the domain name @:operationLog.dict.accountAndName"
  },

  0x033: {
    label: "Confiim lfet time",//确定终身绑定
    code: 0x033,
    logInfo: "confiim lfet time domainName： {targetName} id: {targetAccount} "
  },
  0x034: {
    label: "Unbind Life Time",//解除终身绑定
    code: 0x034,
    logInfo: "Unbind Life Time  domainName: {targetName} id: {targetAccount} "
  },
  0x035: {
    label: "Bind Model",//机型绑定
    code: 0x035,
    logInfo: "Bind Model domainName: {targetName} model id: {targetAccount}"
  },

  0x036: {
    label: "Remove model",//移除机型
    code: 0x036,
    logInfo: "Remove model  domainName：{targetName} model id: {targetAccount}"
  },

  0x037: {
    label: "Remove imei", //删除imei
    code: 0x037,
    logInfo: "Remove imei  Account：{targetAccount} imei: {targetName}"
  },

  0x038: {
    label: "Imei batchRange Create", //imei 区间新增
    code: 0x038,
    logInfo: "Imei create  account：{targetAccount} start and end Data: {targetName}"
  },

  0x039: {
    label: "imei create", // imei批量新增
    code: 0x039,
    logInfo: "imei create  account：{targetAccount} imei info: {targetName}"
  },

  0xd040: {
    label: "Modify the Account",//修改账号
    code: 0xd040,
    logInfo: "Modify the Account @:operationLog.dict.accountAndName  new: {attribute1} old: {attribute2} "
  },

  0xf04:{
    label: "Add iccid",//增加iccid
    code: 0xf04,
    logInfo:" Add iccid:  {targetName}   The target account: {originAccount}"
  },
  0xf06:{
    label: "Increase iccid in batch",//批量新增iccid
    code: 0xf06,
    logInfo:"Increase iccid in batch:  {targetName}   The target account: {originAccount}"
  },
  0xf07:{
    label: "Increase iccid in intervals",//区间增加iccid
    code: 0xf07,
    logInfo:"Increase iccid in intervals: {targetName}   The target account: {originAccount}"
  },
  0xf05:{
    label: "Recycling iccid",//回收iccid
    code: 0xf05,
    logInfo:"Recycling iccid: {originName} The target account: {originAccount}"
  },
  0x50: {
    label: "Create a monitor ",
    code: 0x50,
    logInfo: "Monitor name and id:{originName},{originId}  TerminalId:{originAccount}"
  },

  0x51: {
    label: "Delete the listening",
    code: 0x51,
    logInfo: "Delete the listening group:{originName},{originId} TerminalId:{originAccount}"
  },

  0x52: {
    label: "Private network binding",
    code: 0x52,
    logInfo: "Private network binding data:{originName},TerminalId: {originId}, Terminal account:{originAccount}"
  },

  0x53: {
    label: "Private network termination",
    code: 0x53,
    logInfo: "Private network termination data:{originName},TerminalId: {originId}, Terminal account:{originAccount}"
  },
  0x54: {
    label: "Organization transfer",
    code: 0x54,
    logInfo:"Organization transfer:User:{originAccount} form {targetId} rank {targetName} transfer to ：{originId} rank {originName}"
  },

  0x55: {
    label: "Create a radio",//创建广播
    code: 0x55,
    logInfo: "creator:{originName},{originAccount} Radio name:{targetAccount}"
  },
  0x56: {
    label: "Create a group",
    code: 0x56,
    logInfo: "creator:{originName},{originAccount} Organization Account/Name/Flag:{targetAccount} The selected user:{targetName}"
  },
  0x57: {
    label: "Delete the organization",
    code: 0x57,
    logInfo: "Delete the people:{originName},{originAccount} Organize information:{targetAccount}"
  },

  0x58: {
    label: "Bulk user tied orders",//批量用户绑订单
    code: 0x58,
    logInfo: "Bulk user tied orders，Account:{originAccount} ,Order:{originName}"
  },

  0x59: {
    label: "Batch users are divided into Q coins",//批量用户划分Q币
    code: 0x59,
    logInfo: "Batch users are divided into Q coins，Account:{originAccount} ,Q-coins:{originName}"
  },

  0x60: {
    label: "(Batch) User modification function",//（批量）用户修改功能
    code: 0x60,
    logInfo: "(Batch) User modification function，Account:{originAccount} ,{originName}"
  },

  0x61: {
    label: "(Batch) Set secondary management for users",
    code: 0x61,
    logInfo: "(Batch) Set secondary management for users，Account:{originAccount} ,name:{originName}"
  },


};


let admin =  [
  logEventType[0x000],  //用户登录
  logEventType[0x001],  //用户登出
  logEventType[0xa00],  //新增代理
  // logEventType[0xa01],  //编辑代理
  logEventType[0xa02],  //删除代理
  logEventType[0xa03],  //暂停代理
  logEventType[0xa04],  //修改代理
  //  logEventType[0xb00],  //修改密码
  logEventType[0xb01],  //密码重置
  logEventType[0xb02],  //修改域名
  logEventType[0xc00],  //新增管理
  logEventType[0xc01],  //修改管理
  logEventType[0xc02],  //删除管理
  logEventType[0xc03],  //暂停管理
  logEventType[0xc05],  //恢复管理
  logEventType[0xf03], //下发广播
  logEventType[0x026], //账号转移
  logEventType[0x027], //终止终端
  logEventType[0x028], //恢复终端
  logEventType[0x029], //恢复会计
  logEventType[0x030], //暂停会计
  logEventType[0x031], //暂停域名
  logEventType[0x032], //恢复域名
  logEventType[0xf04], //新增iccid
  logEventType[0xf05], //回收iccid
  logEventType[0xf06], //批量新增iccid
  logEventType[0xf07], //区间新增iccid
  logEventType[0x033],//确定终身绑定
  logEventType[0x034],//解除终身绑定
  logEventType[0x035],//机型绑定
  logEventType[0x036],//移除机型
  logEventType[0x037],//删除imei
  logEventType[0x038],//imei批量新增
  logEventType[0x039],//imei新增
];

let proxy =[
  logEventType[0x000],
  logEventType[0x001],
  logEventType[0x04], //新增企业
  logEventType[0x05], //删除企业
  logEventType[0x02], //修改企业
  logEventType[0x03], //暂停企业
  // logEventType[0xb00],  //修改密码
  logEventType[0xb01], //密码重置
  logEventType[0x10], //新增子代理
  logEventType[0x11], //删除子代理
  logEventType[0x12], //修改子代理
  logEventType[0x13], //暂停子代理
  logEventType[0xc00],  //新增管理
  logEventType[0xc01],  //修改管理
  logEventType[0xc02],  //删除管理
  logEventType[0xc03],  //暂停管理
  logEventType[0xc05],  //恢复管理
  logEventType[0x14], //子代理密码重置
  logEventType[0xc04],  //管理密码重置
  logEventType[0x026], //账号转移
  logEventType[0x027], //终止终端
  logEventType[0x028], //恢复终端
];

let subagent =[
  logEventType[0x000],
  logEventType[0x001],
  logEventType[0x04], //新增企业
  logEventType[0x05], //删除企业
  logEventType[0x02], //修改企业
  logEventType[0x03], //暂停企业
  // logEventType[0xb00],  //修改密码
  logEventType[0xb01], //密码重置
  logEventType[0xc00],  //新增管理
  logEventType[0xc01],  //修改管理
  logEventType[0xc02],  //删除管理
  logEventType[0xc03],  //暂停管理
  logEventType[0xc05],  //恢复管理
  logEventType[0xc04],  //管理密码重置
  logEventType[0x026], //账号转移
  logEventType[0x027], //终止终端
  logEventType[0x028], //恢复终端

];

var enterprise = [
  logEventType[0x000],
  logEventType[0x001],
  logEventType[0xd01], //新增用户
  logEventType[0xd02], //修改用户
  logEventType[0xd040], //修改用户
  // logEventType[0xd03], //删除用户0xd04
  //logEventType[0xd04], //暂停用户
  logEventType[0xe01], //新增群组
  logEventType[0xd00], //批量新增用户
  logEventType[0xe00], //批量新增群组
  logEventType[0xe02], //修改群组信息
  logEventType[0xe03], //群组增加成员
  logEventType[0xe07], //用户添加群组
  logEventType[0xe04], //群组删除成员
  logEventType[0xe05], //群组暂停
  logEventType[0xe08], //群组恢复
  logEventType[0xe06], //群组删除
  logEventType[0xf00], //增加好友
  logEventType[0xf01], //删除好友
  logEventType[0xf02], //消息管理
  logEventType[0xf03], //下发广播
  logEventType[0x21],  //新增二级管理
  logEventType[0x22],  //修改二级管理
  logEventType[0x23],  //删除二级管理
  logEventType[0x24],  //暂停二级管理
  logEventType[0xf08],  //恢复二级管理
  logEventType[0x25],  //二级管理密码重置
  logEventType[0xc00],  //新增管理
  logEventType[0xc01],  //修改管理
  logEventType[0xc02],  //删除管理
  logEventType[0xc03],  //暂停管理
  logEventType[0xc05],  //恢复管理
  logEventType[0x026],  //账号转移
  logEventType[0x027],  //暂停终端
  logEventType[0x028],  //恢复终端
  logEventType[0xf04], //新增iccid
  logEventType[0xf05], //回收iccid
  logEventType[0xf06], //批量新增iccid
  logEventType[0xf07], //区间新增iccid
  logEventType[0x52],  //专网绑定
  logEventType[0x53],  //专网解除
  logEventType[0x54],  //组织转移
  logEventType[0x50],  //添加监听
  logEventType[0x51],  //删除监听
  logEventType[0x55],  //删除监听
  logEventType[0x56],  //添加组织
  logEventType[0x57],  //删除组织
  logEventType[0x58],
  logEventType[0x59],
  logEventType[0x60],
  logEventType[0x61],


];

//角色下拉框
let roleLogOption = {
  1:admin,
  5:admin,
  6:admin,
  2:proxy,
  8:proxy,
  9:proxy,
  3:subagent,
  10:subagent,
  11:subagent,
  4: enterprise,
  12: [
    logEventType[0x000],

  ],
  13: enterprise,
  14: [
    logEventType[0x000],
    logEventType[0x001],
    logEventType[0xd02], //修改用户
    logEventType[0xd040], //修改用户
    // logEventType[0xd03], //删除用户0xd04
    //logEventType[0xd04], //暂停用户
    logEventType[0xe01], //新增群组
    logEventType[0xe02], //修改群组信息
    logEventType[0xe03], //群组增加成员
    logEventType[0xe04], //群组删除成员
    logEventType[0xe05], //群组暂停
    logEventType[0xe06], //群组删除
    logEventType[0x027], //终止终端
  ]
};

const operationLog = {
  //数据字典
  dict: {
    role: "{originRole,select,1{Admin} 2{Proxy} 3{Subagent} 4{Enterprise}  other{ } 5{General agent management} 6{General agent information}" +
    "7{user} 8{Agency management} 9{Agent information management} 10{Subagent information query} 11{sub-agent enterprise management} 12{Enterprise information query} " +
    "13{Enterprise user management} 14{Level 2 enterprise} 15{Information query of secondary enterprises} 16{ accountant} 17{Subagent new enterprises} 18{group}}",
    accountAndName: " @:operationLog.dict.role Account:{originAccount} , @:operationLog.dict.role Name:{originName}",
    groupLog: " GroupId：{groupId}，GroupName:{groupName}，Account:{terminalAccount}。",
    domain:" @:operationLog.dict.role账号:{originAccount} , @:operationLog.dict.role名称:{originName} Old domain name{attribute1} New domain name{attribute2}",
    group:"groupname:{groupName}",
    operatorRoless: "@:operationLog.dict.role:{operatorRole}",
    targetAccount:"{targetAccount}",
    targetId:"{targetId}",
    myAccount:"{originAccount}",
    targetName:"{targetName}",
    originId:"{originId}",
  },
  roleLogOption,
  logEventType
};


export default operationLog;



// WEBPACK FOOTER //
// ./src/api/lang/modules/oplog/operationLog_en.js